<template>
  <div class="modiset">
    <!-- {{this[`${ses.shows}`] }} -->
    {{ search }}
    <!-- <el-input v-model.lazy="search" @click.native="inputClick" ref="parentInput" @input="inputs" @change="changes"></el-input> -->
    <!-- <el-input v-model.number="search"  ref="parentInput" @input="inputs" @change="changes"></el-input> -->
    <inputComent :ancient-show="ancientShow" ref="parentInput" v-model="search"></inputComent>
    <!-- <OnlineIndex  actions="/portal/word/listWordView" top="3rem" left="7rem" ref="online" :ancient-value="ancientValue"></OnlineIndex> -->
  </div>

</template>

<script>
  import inputComent from '../../components/online/InputComent.vue';

  export default {
    name: 'PortalDd',
    components: {
      OnlineIndex: () => import('../../components/online/index.vue'),
      inputComent
    },
    data() {
      return {
        search: '测试',
        searchstore: '',
        show: true,
        testshow: false,
        // 光标位置
        selectionStart: '',
        ancientShow: true,
        ancientValue: '1'
      };
    },

    mounted() {

    },

    methods: {
      inputClick(e) {
        this.selectionStart = e.srcElement.selectionStart
        this.$refs.parentInput.$refs.input.setRangeText('~');
        this.$refs.parentInput.$refs.input.setSelectionRange(this.selectionStart + 1, this.selectionStart + 1);
      },
      inputChange(e) {
        if (this.show) {
          this.$refs.online.handShow = true
          this.$refs.online.methFocus()
        }
      },

      inputs(e) {
        console.log(e, 'inputs');
      },
      changes(e) {
        console.log(e, 'changes');
      }
    },
    // watch: {
    //   search: {
    //     handler: function (handlnew,handlold) {

    //     },
    //     deep: true
    //   }
    // }
  };
</script>

<style lang="less" scoped>
  .modiset {
    font-family: 壮文宋体;
    position: relative;
    width: 50%;
    margin: 0 auto;

    /deep/ .el-input {
      font-family: 壮文宋体;

      .el-input__inner {
        font-family: "壮文宋体";
      }
    }
  }
</style>
